import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'

type Params = {
  proposalId: string
}

const getInstallments = async (params: Params): Promise<any> => {
  const result = await axios.get(
    `financial/proposals/${params.proposalId}/installments`
  )
  return result
}

export function useGetProposalInstallments({ proposalId }: Params) {
  return useQuery(
    ['get-proposal-installments', proposalId],
    () => getInstallments({ proposalId }),
    {
      enabled: !!proposalId,
      onSuccess: (data) => {
        return data
      },
      onError: (error: unknown) => {
        console.error(error)
        toast.error('Não foi possível obter a simulação.')
      }
    }
  )
}
